import { apiService } from './api';

export interface PublishQuestionsRequest {
    yearId: number;
    entityIds: string[];
    areaIds: string[];
    questionIds: string[];
    itemIds: string[];
    actionIds: string[];
}

export interface QuestaoResponse {
    [x: string]: any;
    questaoId: string;
    titulo: string;
    descricao: string;
    areaId: string;
    itemIds: string[];

}

export interface Questao {
    titulo: string;
    descricao: string;
    status: string;
    score: number;
    questao_id: string;
    usuario_responsavel_id: string;
    entidade_id: string;
    area_id: string;
    questao_base_id: string;
    ano: number;
    total_items: number;
}

export interface QuestaoRequest {
    titulo: string;
    descricao: string;
    ano: number;
    responsavelId?: string;
}

export interface AtualizarQuestaoRequest {
    titulo: string;
    descricao: string;
    ano: number;
    usuarioResponsavelId?: string;
}

export interface HistoricoScoreItem {
    ano: number;
    nota: number;
    variacao: number;
}

export interface HistoricoScoreResponse {
    tipo: string;
    id: string;
    titulo: string;
    descricao: string;
    historico: HistoricoScoreItem[];
}

export const questionService = {

    // Get questions for a specific user, entity, area, and year
    async getQuestionsForUser(entidadeId: string, areaId: string, ano: number): Promise<Questao[]> {
        try {
            const url = `/questao/${entidadeId}/${areaId}/${ano}/usuario`;
            const response = await apiService.get<Questao[]>(url);
            return response;
        } catch (error) {
            console.error('Error fetching questions for user:', error);
            throw error;
        }
    },

    // Create a new question
    async createQuestion(entidadeId: string, areaId: string, request: QuestaoRequest): Promise<QuestaoResponse> {
        try {
            const response = await apiService.post<QuestaoResponse>(`/questao/${entidadeId}/${areaId}`, request);
            return response;
        } catch (error) {
            console.error('Error creating question:', error);
            throw error;
        }
    },

    // Update an existing question
    async updateQuestion(questaoId: string, request: AtualizarQuestaoRequest): Promise<QuestaoResponse> {
        try {
            const response = await apiService.put<QuestaoResponse>(`/questao/${questaoId}`, request);
            return response;
        } catch (error) {
            console.error('Error updating question:', error);
            throw error;
        }
    },

    // Publish questions for a specific year
    async publishQuestionsForYear(request: PublishQuestionsRequest): Promise<void> {
        try {
            let url = `/questao/publicar/${request.yearId}`;

            // Add entity IDs as required query parameters
            const entityIdsParam = request.entityIds.map(id => `entityIds=${id}`).join('&');
            url += `?${entityIdsParam}`;

            // Create request body with questions, items, and actions
            const requestBody = {
                areaIds: request.areaIds,
                questionIds: request.questionIds,
                itemIds: request.itemIds,
                actionIds: request.actionIds
            };

            await apiService.post(url, requestBody);
        } catch (error) {
            console.error('Error publishing questions for year:', error);
            throw error;
        }
    },

    async getScoreHistory(entidadeId: string, areaId: string, tipo: string): Promise<HistoricoScoreResponse[]> {
        try {
            const url = `/questao/${entidadeId}/${areaId}/historico-score?tipo=${tipo}`;
            const response = await apiService.get<HistoricoScoreResponse[]>(url);
            return response;
        } catch (error) {
            console.error('Error fetching score history:', error);
            throw error;
        }
    }
};
